export default "__VITE_ASSET__Dw5TjM8l__"